module.exports = __webpack_public_path__ + "img/cake.4bb4886c.png";